import PropTypes from 'prop-types';

import {Box, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

import {NotImplemented} from '@amblique/contentful/app/components/contentful/not-implemented';
import {CalloutBlockOverlayCF024} from '@amblique/king-living/app/contentful/models/hero-banner/callout-block-overlay-cf024';
import {CalloutBlockSplitCF023} from '@amblique/king-living/app/contentful/models/hero-banner/callout-block-split-cf023';
import {HeroBannerBlockCF01} from '@amblique/king-living/app/contentful/models/hero-banner/hero-banner-block-cf01';
import {HeroBannerBlockCF04} from '@amblique/king-living/app/contentful/models/hero-banner/hero-banner-block-cf04';
import {HeroBannerBlockCF06} from '@amblique/king-living/app/contentful/models/hero-banner/hero-banner-block-cf06';

/**
 * HeroBanner component
 *
 * @param {Object} props - Component props
 * @param {Contentful.HeroBanner} props.component - HeroBanner component data
 * @param {boolean} [props.isComplete] - Whether component has all fields
 * @param {boolean} [props.isFetching] - Whether additional data is being fetched
 * @returns {React.ReactElement}
 */
export const HeroBanner = ({component, isComplete = true, isFetching = false, ...props}) => {
  const {appearance} = component;
  const styles = useMultiStyleConfig('contentful/hero-banner', {
    component,
    isComplete,
    isFetching,
    variant: appearance,
  });

  return (
    <Box {...styles.root} {...props}>
      {appearance === 'Hero Banner Block (CF-01)' ? (
        <HeroBannerBlockCF01 component={component} isComplete={isComplete} isFetching={isFetching} styles={styles} />
      ) : appearance === 'Hero Banner Block (CF-04)' ? (
        <HeroBannerBlockCF04 component={component} isComplete={isComplete} isFetching={isFetching} styles={styles} />
      ) : appearance === 'Hero Banner Block (CF-06)' ? (
        <HeroBannerBlockCF06 component={component} isComplete={isComplete} isFetching={isFetching} styles={styles} />
      ) : appearance === 'Callout Block - Split (CF-023)' ? (
        <CalloutBlockSplitCF023 component={component} isComplete={isComplete} isFetching={isFetching} styles={styles} />
      ) : appearance === 'Callout Block - Overlay (CF-024)' ? (
        <CalloutBlockOverlayCF024 component={component} isComplete={isComplete} isFetching={isFetching} styles={styles} />
      ) : (
        <NotImplemented component={component} isComplete={isComplete} isFetching={isFetching} />
      )}
    </Box>
  );
};

HeroBanner.displayName = 'HeroBanner';
HeroBanner.propTypes = {
  component: PropTypes.object.isRequired,
  isComplete: PropTypes.bool,
  isFetching: PropTypes.bool,
};
